import React, { useContext, useEffect, useState } from "react";

import "./stylesTransactions.css";
import Layout from "../CommonComponents/Layout/Layout";

import AppContext from "../../context/AppContext";
import { SIDER_TABS } from "../../utils/Constants";
import TransactionRoutes from "./Processors/TransactionRoutes/TransactionRoutes";
import { PlusOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import NewRouteModal from "./Processors/NewRouteModal/NewRouteModal";

function Transactions() {
  const { setActiveSidebarTab } = useContext(AppContext);
  const [data, setData] = useState([
    {
      key: "1",
      name: "Transaction 1",
      minAmount: 2,
      maxAmount: 12,
      primaryProcessor: "Finix",
      period: "Daily",
      max: 100,
      maxDollar: 1000,
      activity: "Active",
    },
    {
      key: "2",
      name: "Transaction 2",
      minAmount: 22,
      maxAmount: 32,
      primaryProcessor: "Finix",
      period: "7 days",
      max: 200,
      maxDollar: 2000,
      activity: "Inactive",
    },
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const tabs = ["Transactions Routes"];

  const [activeTab, setActiveTab] = useState("Transactions Routes");

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.TRANSACTIONS, "Processors");
  }, []);

  return (
    <Layout>
      <div className="transactions-container">
        <div className="transactions">
          <>
            <Modal
              closable={false}
              open={isModalOpen}
              onOk={handleOk}
              onCancel={handleCancel}
              footer={null}
              width={800}
            >
              <NewRouteModal handleCancel={handleCancel} />
            </Modal>
            <div className="head-controls">
              <div className="header-text-container">
                <p className="header-text">Processors</p>
                <button onClick={showModal}>
                  <PlusOutlined className="plus-icon" />
                  Create New Route
                </button>
              </div>
            </div>
            <div className="dashboard-tabs">
              {tabs.map((tab) => (
                <button
                  className={activeTab === tab ? "active" : null}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <TransactionRoutes data={data} />
          </>
        </div>
      </div>
    </Layout>
  );
}

export default Transactions;
